import { computed } from '@vue/composition-api';
export const useSidebar = (ctx) => {
    const showSidebar = computed(() => ctx.root.$route.meta?.sidebar);
    return { showSidebar };
};
